export const DATA_FIRESTORE_V01_EVENT_SCHEDULING = {
  NAME: 'v01_event_scheduling',
}
